/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sync_Judges_DescInputs */



/**
* | output |
* | --- |
* | "Set Judge and Sheriff from the VTES Exams judge directory. Runs automatically every 24 hours." |
*
* @param {Admin_Sync_Judges_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_sync_judges_desc = /** @type {((inputs?: Admin_Sync_Judges_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sync_Judges_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribue Judge et Sheriff depuis l'annuaire des arbitres de VTES Exams. S'exécute automatiquement toutes les 24 heures.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asigna Judge y Sheriff desde el directorio de jueces de VTES Exams. Se ejecuta automáticamente cada 24 horas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Atribui Judge e Sheriff a partir do diretório de juízes do VTES Exams. Executa automaticamente a cada 24 horas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegna Judge e Sheriff dall'elenco dei giudici di VTES Exams. Viene eseguita automaticamente ogni 24 ore.")
	return /** @type {LocalizedString} */ ("Set Judge and Sheriff from the VTES Exams judge directory. Runs automatically every 24 hours.")
});